import { stores } from './stores';
import { cities } from './cities';

// Generate realistic customers
const firstNames = ['Rahul', 'Priya', 'Amit', 'Sneha', 'Vikram', 'Anjali', 'Raj', 'Neha', 'Arjun', 'Kavita',
    'Suresh', 'Meera', 'Karan', 'Pooja', 'Deepak', 'Ritu', 'Sanjay', 'Divya', 'Arun', 'Swati',
    'Manish', 'Nisha', 'Rohit', 'Anita', 'Vivek', 'Shweta', 'Gaurav', 'Preeti', 'Nikhil', 'Shruti'];
const lastNames = ['Sharma', 'Patel', 'Singh', 'Kumar', 'Gupta', 'Verma', 'Reddy', 'Joshi', 'Agarwal', 'Shah',
    'Mehta', 'Iyer', 'Nair', 'Rao', 'Das', 'Mishra', 'Kapoor', 'Malhotra', 'Bhatia', 'Chopra'];

function generateCustomers(count = 800) {
    const customers = [];
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

    for (let i = 1; i <= count; i++) {
        const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
        const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
        const store = stores[Math.floor(Math.random() * stores.length)];

        // Registration date within 6 months
        const registrationDate = new Date(sixMonthsAgo.getTime() + Math.random() * (Date.now() - sixMonthsAgo.getTime()));

        // Determine if new (registered in last 30 days)
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        const isNew = registrationDate > thirtyDaysAgo;

        customers.push({
            id: `CUST-${String(i).padStart(5, '0')}`,
            name: `${firstName} ${lastName}`,
            email: `${firstName.toLowerCase()}.${lastName.toLowerCase()}${i}@email.com`,
            phone: `+91 ${9000000000 + Math.floor(Math.random() * 999999999)}`,
            cityId: store.cityId,
            storeId: store.id,
            pincode: store.pincode,
            registrationDate: registrationDate.toISOString().split('T')[0],
            isNew,
            isRepeat: !isNew && Math.random() > 0.3, // 70% of non-new customers are repeat
            totalOrders: isNew ? Math.floor(Math.random() * 3) + 1 : Math.floor(Math.random() * 15) + 1,
            lifetimeValue: 0, // Will be calculated from orders
        });
    }

    return customers;
}

export const customers = generateCustomers(800);

// Helper functions
export function getCustomerById(customerId) {
    return customers.find(cust => cust.id === customerId);
}

export function getCustomersByCity(cityId) {
    return customers.filter(cust => cust.cityId === cityId);
}

export function getCustomersByStore(storeId) {
    return customers.filter(cust => cust.storeId === storeId);
}

export function getNewCustomers() {
    return customers.filter(cust => cust.isNew);
}

export function getRepeatCustomers() {
    return customers.filter(cust => cust.isRepeat);
}

export function getRandomCustomer() {
    return customers[Math.floor(Math.random() * customers.length)];
}

export default customers;
